<template>
  <div id="app">
    <header>
      <dicta-header :englishSupported="true"></dicta-header>
      <div v-bind:class="(devMode ? 'bg-danger' : 'bg-primary') + ' second-header d-flex'">
        <div class="container">
          <div class="row">
            <div class="col-8">
              <router-link to="/"> 
                <div class="logo-div">  
                  <div class="logo">
                    <img src="@/assets/logo.png" alt="logo"/>
                  </div>                  
                    <div class="d-inline-block mx-2">
                    <div class="tool-name">{{hebrew ? 'איתור מקבילות' : 'Parallels Finder'}}</div>
                    <small class="d-block dicta">{{hebrew ? 'גרסת אלפא' : 'Alpha Version'}}</small>
                  </div>
                </div>
              </router-link> 
            </div>
            <div 
              class="col-4" 
              :class = "hebrew ? 'text-left' : 'text-right'">
              <div class="d-block d-sm-none">
              <mobile-menu                 
                class="mt-2 text-body"  
                @showHowDialog="showAbout=true" 
                :englishSupported="true" 
                :howDialog="true"               
                
                >
              </mobile-menu>
              </div>
              <b-button 
                id="getInstructionsBttn" 
                variant="primary"
                class="btn-outline-light d-none d-md-inline-block" 
                size="md"                 
                @click="showAbout = true">
                {{hebrew ? 'איך זה עובד' : 'How it works'}}
              </b-button>
            </div>  
          </div>
        </div>
      </div>
    </header>  
    <router-view></router-view>
    <about-dialog v-model="showAbout"></about-dialog>
  </div>
</template>

<script>

import AboutDialog from "@/components/aboutDialog";
import {isThisAppInDevMode} from './devMode'

export default {
  name: 'app',
  components: {
    AboutDialog,
  },
  data() {
    return {
      showAbout:false
    }
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search)
    const lang = urlParams.get('lang')
    if (this.$cookies.get('DICTA_USE_HEBREW') !== null) {
      this.$settings.hebrew = (this.$cookies.get('DICTA_USE_HEBREW') === 'true')
    } else if (lang !== null) {
      this.$settings.hebrew = lang.includes('he')
    } else {
      this.$settings.hebrew = true
    }
    if (this.$settings.hebrew) {
      document.body.classList.add('he')
    } else {
      document.body.classList.remove('he')
    }          
  },
  computed: {
    devMode () { return isThisAppInDevMode('parallels') },
    hebrew () {
      return this.$settings.hebrew
    }
  }  
}
</script>

<style lang="scss">
@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/mft_narkisclassic-regular.woff') format('woff');
  font-style: normal;
  font-weight: normal;
  text-rendering: optimizeLegibility;
}
@font-face {
  font-family: 'mft_narkisclassic';
  src: url('assets/fonts/MFTW_NarkisClassicBold.woff') format('woff');
  font-style: normal;
  font-weight: bold;
}

a{
  cursor: pointer;    
}
.f-narkis{
  font-family: Roboto, mft_narkisclassic, sans-serif;
  line-height: 1.5;
}
.rounded-top {
  border-top-right-radius: 4px!important;
  border-top-left-radius: 4px!important;
}
.rounded-bottom {
  border-bottom-right-radius: 4px!important;
  border-bottom-left-radius: 4px!important;
} 
.centered {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dicta-dropdown .dropdown-item{text-align: left;}
.he .dicta-dropdown .dropdown-item{text-align: right;}  

.modal-footer{
  direction: ltr;
}
.he .modal-footer{
  direction: rtl;
}

.search-link{
  line-height: 28px;
  margin-top: 3px;
  &:hover{
    text-decoration: none;
    background:var(--secondary);
  }
}
</style>

<style lang="scss" scoped>
.second-header {
  direction: ltr;
  height:50px;
  color: white;
  justify-content: space-between;
  align-items: center;
  .dicta {
    line-height: 14px;    
    opacity: .7;
    font-family: 'Arimo';        
  }
  a{
    color:white;
    text-decoration:none;
    &:hover{
      text-decoration: none;
    }
  }  
  .btn-outline-light{
    margin-top:2px;
  }
}
.he .second-header{
  direction: rtl;
}
.logo-div {
  display: flex;
  align-items: center;
  .tool-name {
    line-height: 20px;
  }
}
.logo {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background:white;
  border-radius:50%;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.main-content {
  flex: auto;
  min-height: 500px;
}
</style>
